(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/common/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/common/assets/javascripts/utils.js');
"use strict";

const accountBalance = svs.components.account_balance;
const OddsmindConstants = svs.oddset_kambi.components.common.constants.OddsmindConstants;
const updateBalance = () => {
  accountBalance.get(true, balance => {
    accountBalance.set(balance);
  });
};
const betslipBottomOffset = isSmallScreen => isSmallScreen ? String(OddsmindConstants.BETSLIP_HEIGHT + OddsmindConstants.MOBILE_NAVMENU_HEIGHT) : String(OddsmindConstants.DESKTOP_BETSLIP_OFFSET);
const noBetslipBottomOffset = isSmallScreen => isSmallScreen ? String(OddsmindConstants.MOBILE_NAVMENU_HEIGHT) : String(OddsmindConstants.DESKTOP_BETSLIP_OFFSET);
const signedInTopOffset = isSmallScreen => isSmallScreen ? String(OddsmindConstants.MOBILE_HEADER_HEIGHT_SIGNED_IN) : '';
const notSignedInTopOffset = isSmallScreen => isSmallScreen ? String(OddsmindConstants.MOBILE_HEADER_HEIGHT) : '';
const getOddsmindOffset = _ref => {
  let isLoggedIn = _ref.isLoggedIn,
    isSmallScreen = _ref.isSmallScreen,
    betslipStatus = _ref.betslipStatus,
    headerVisible = _ref.headerVisible;
  if (isLoggedIn) {
    return {
      top: headerVisible ? signedInTopOffset(isSmallScreen) : String(OddsmindConstants.LI_BAR),
      bottom: betslipStatus === OddsmindConstants.BETSLIP_VISIBLE ? betslipBottomOffset(isSmallScreen) : noBetslipBottomOffset(isSmallScreen)
    };
  }
  return {
    top: headerVisible ? notSignedInTopOffset(isSmallScreen) : String(OddsmindConstants.LI_BAR),
    bottom: betslipStatus === OddsmindConstants.BETSLIP_VISIBLE ? betslipBottomOffset(isSmallScreen) : noBetslipBottomOffset(isSmallScreen)
  };
};
setGlobal('svs.oddset_kambi.components.common.utils', {
  updateBalance,
  getOddsmindOffset
});

 })(window);